<template>
  <transition name="fade-in">
    <nav v-if="open" class="nav-Mobile">
      <MobileMenuToggle collapsed class="pt-3 pr-2 d-block ml-auto" />
      <div class="mt-2">
        <slot></slot>
      </div>
    </nav>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import MobileMenuToggle from "./MobileMenuToggle";

export default {
  components: {
    MobileMenuToggle,
  },
  computed: {
    ...mapGetters({
      open: "getNavigationOpenState",
    }),
  },
  watch: {
    open(state) {
      if (!state) {
        document.querySelector(".sw-Body_Inner").classList.remove("overflow-hidden");
      } else {
        document.querySelector(".sw-Body_Inner").classList.add("overflow-hidden");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.nav-Mobile {
  background-color: $gray-200;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: $zi-mobilenav;

  @media (min-width: $screen-lg-min) {
    display: none;
  }
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity $transition-duration;
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}
</style>
